import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/node_modules/.pnpm/@mui+material@7.0.2_@emotion+react@11.14.0_@types+react@19.1.2_react@19.1.0__@emotion+s_16c1d2f6f86d9de5116733da56994f75/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/(ambassador)/ambassador-regist/components/AmbassadorRegistForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/Image/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
